module.exports = __webpack_public_path__ + "img/pr-19.3f911b6c.png";